// EAIRI — runtime configuration.
//
// Everything the browser needs to know, read once and validated at startup so
// a missing variable is a clear message rather than a fetch to "undefined/...".

export interface AppConfig {
  readonly functionsUrl: string;
  readonly configured: boolean;
}

function read(name: string): string {
  const v = (import.meta.env as Record<string, string | undefined>)[name];
  return typeof v === "string" ? v.trim() : "";
}

export function loadConfig(): AppConfig {
  const functionsUrl = read("VITE_EAIRI_FUNCTIONS_URL");
  return { functionsUrl: functionsUrl.replace(/\/+$/, ""), configured: functionsUrl.length > 0 };
}

export const config = loadConfig();
